import { API_ERROR_MESSAGES, type ApiErrorCode } from "@ckgo2/shared";

// API error codes → English text (vize F13.9). The English source IS the API registry
// (`packages/shared/src/apiErrors.ts`) — one English wording, no second copy to drift.
// Widened to `string` (not `as const`) so the Czech mirror can be typed `typeof apiErrors`.
// Keys are exactly the registry codes: a new code without its Czech twin fails typecheck,
// and `scripts/kontrola/chybove-kody.mjs` (rule D) checks both directions.
export const apiErrors: Record<ApiErrorCode, string> = { ...API_ERROR_MESSAGES };
